<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-col cols="12" md="6">
              <span><b>Notifications</b></span>
            </b-col>

            <b-row class="text-left" align-v="center">
              <b-col cols="12" md="2" class="pt-3">
                <b-button
                  variant="primary"
                  style="padding-top: 6px; padding-bottom: 6px"
                  size="sm"
                  @click.prevent="sendNotification"
                  >Send New Notification</b-button
                >
              </b-col>
              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select From Date:</span
                ><br />
                <b-form-input
                  class="pt-1"
                  v-model="from"
                  type="date"
                  id="date1"
                  @change="dateSetting"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select To Date:</span
                ><br />
                <b-form-input
                  class=""
                  v-model="to"
                  type="date"
                  id="date"
                  @change="dateSetting"
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  variant="outline-primary"
                  size="sm"
                  id="dropdown-1"
                  :text="chartName"
                >
                  <b-dropdown-item
                    v-for="(item, i) in chartTypes"
                    :key="i"
                    @click="updateChart(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="12" md="4" class="pt-3">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="md"
                      ></b-form-input>
                      <!-- <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item.keyword}}</option>
                      </datalist> -->
                    </b-col>
                    <b-col cols="2" sm="2" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                    <b-col cols="1" sm="1" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        class="px-2"
                        size="sm"
                        to="/notifications"
                        >All</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="notifications"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template slot="slno" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.createddate">{{ data.index + 1 }}</span>
              </div>
            </template>
            <template slot="createddate" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.createddate">{{
                  formatDate(data.item.createddate)
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalNotifications"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import addNotification from "./addNotification";
import axios from "axios";
export default {
  data: () => {
    return {
      notifications: [],
      from: null,
      to: null,
      chartName: "Filter",
      chartType: null,
      chartTypes: [
       { name: "Last 90 Days", value: 90 },
        { name: "Last 60 Days", value: 60 },
        { name: "Last 30 Days", value: 30 },
        { name: "Last 15 Days", value: 15 }
      ],
      fields: [
        // { key: "slno", label: "Sl. No", sortable: false },
        { key: "createddate", label: "Created On", sortable: true },
        { key: "title", label: "Title", sortable: true },
        { key: "body", label: "Body", sortable: true, tdClass: "tdwidth" },
        { key: "userid.name", label: "Created By", sortable: true },
      ],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      totalNotifications: 0,
      searchData: [],
      searchKey: null,
    };
  },
  mounted() {
    this.searchKey = this.$route.query.searchKey;
    this.from = this.$route.query.from;
    this.to = this.$route.query.to;
    this.chartType = this.$route.query.chartType;
    for (var i = 0; i < this.chartTypes.length; i++) {
      if (this.chartType == this.chartTypes[i].value) {
          this.chartName = this.chartTypes[i].name;
        return;
      } 
    }
    this.mySearch();
  },
  watch: {
    "$route.fullpath": {
      handler: function () {
        this.mySearch();
      },
      deep: true,
    },
  },
  methods: {
    sendNotification() {
      this.$dlg.modal(addNotification, {
        width: 1000,
        height: 500,
        title: "Send New Notification to App",
        maxButton: true,
        closeButton: true,
        params: {},
        callback: (data) => {
          if (data.update) {
            this.mySearch();
          }
          if (!data.status) {
            this.ServerError = true;
          }
        },
      });
    },
   
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    dateSetting() {
      this.$router.push({
        path: "/Notifications",
        query: {
          searchKey: this.$route.query.searchKey,
          from: this.from,
          to: this.to,
          chartType: this.$route.query.chartType,
        },
      });
    },
    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
      this.$router.push({
        path: "/Notifications",
        query: {
          searchKey: this.$route.query.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.chartType,
        },
      });
    },

    getSearch() {
      this.$router.push({
        path: "/Notifications",
        query: {
          searchKey: this.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.$route.query.chartType,
        },
      });
    },

    mySearch() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/search/notification",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.$route.query.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          filter: this.$route.query.chartType,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.notifications = response.data.data;
          this.totalNotifications = response.data.count;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/Notifications/" + item._id);
    },
  },
};
</script>

<style >
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}

.tdwidth {
  width: 50% !important;
}
</style>
